import { Drawer, FormControl, FormControlLabel, FormLabel, IconButton, Radio, RadioGroup, Slider, Stack, Switch, Typography } from "@mui/material"
import React from "react";
import { SettingsContext } from "./settingsProvider";
import SettingsIcon from '@mui/icons-material/Settings';
import { useContextWithGuard } from "../helpers/useContextWithGuard";


export const SettingsMenu = () => {
    const { setQuestionHeight, questionHeight,
        // showFaulty, setShowFaulty,
        columnsOverride, setColumnsOverride,
        publishPdfMode, setPublishPdfMode,
        imageScale, setImageScale } = useContextWithGuard(SettingsContext, "SettingsContext");

    const [open, setOpen] = React.useState(false);

    return (
        <>

            <IconButton
                size="large"
                edge="start"
                aria-label="settings"
                sx={{
                    mr: 2,
                    border: 'none !important',
                }}
                aria-haspopup="true"
                onClick={() => setOpen(true)}
                title="settings menu"
                color="primary"
            >
                <SettingsIcon />
            </IconButton>

            <Drawer
                id="menu-appbar"
                open={open}
                onClose={() => setOpen(false)}
            >

                <Stack direction="column" sx={{padding: "20px"}} gap={1} alignItems="start" >
                    <Typography>Question height</Typography>
                    <Slider aria-label="question height"
                        value={questionHeight}
                        onChange={(e, value) => { 
                            setQuestionHeight(value) 
                        }}
                        min={20}
                        max={200}
                        step={10}
                        valueLabelDisplay="auto" />

                    <Typography>Image magnification</Typography>
                    <Slider aria-label="image magnification"
                        value={imageScale}
                        onChange={(e, value) => { setImageScale(value) }}
                        min={0.1}
                        max={2.0}
                        step={0.1}
                        valueLabelDisplay="auto" />
{/* 
                    <FormControlLabel
                        control={<Switch checked={showFaulty} onChange={() => setShowFaulty(!showFaulty)} />}
                        label="show faulty questions"
                        labelPlacement="start"
                    /> */}

                    <FormControl>
                        <FormLabel id="demo-row-radio-buttons-group-label">Columns</FormLabel>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            value={columnsOverride}
                            onChange={(e) => setColumnsOverride(Number(e.target.value))}
                        >
                            <FormControlLabel value="0" control={<Radio />} label="auto" />
                            <FormControlLabel value="1" control={<Radio />} label="1" />
                            <FormControlLabel value="2" control={<Radio />} label="2" />
                        </RadioGroup>
                    </FormControl>

                    <FormControl>
                        <FormLabel id="download-pdf-mode">PDF Download</FormLabel>
                        <RadioGroup
                            row
                            aria-labelledby="download-pdf-label"
                            name="download-pdf-radio-buttons-group"
                            value={publishPdfMode}
                            onChange={(e) => setPublishPdfMode(e.target.value)}
                        >
                            <FormControlLabel value="separate" control={<Radio />} label="separate QP and MS" />
                            <FormControlLabel value="combined" control={<Radio />} label="combined" />
                        </RadioGroup>
                    </FormControl>
                </Stack>
            </Drawer>
        </>
    )
}